import { render } from "./GroupMemberInvite.vue?vue&type=template&id=7eb6b68c"
import script from "./GroupMemberInvite.vue?vue&type=script&lang=js"
export * from "./GroupMemberInvite.vue?vue&type=script&lang=js"
script.render = render

export default script